import './tags-api.factory';
import './tags-requests.service';
import './tags-service.service';
import './tags-dialog.service';
import './tags-alerts.service';
